var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@web/utility';
import React from 'react';
var ButtonLink = function (_a) {
    var children = _a.children, onClick = _a.onClick, className = _a.className, disabled = _a.disabled;
    return (_jsx("button", __assign({ type: "button", className: classNames('text-indigo-600 hover:text-indigo-800 font-medium', disabled ? 'opacity-50 cursor-not-allowed' : '', className), onClick: onClick, disabled: disabled }, { children: children })));
};
export default ButtonLink;
